import { render, staticRenderFns } from "./ArrivalCaptureDetail.vue?vue&type=template&id=4e9bc866&scoped=true"
import script from "./ArrivalCaptureDetail.vue?vue&type=script&lang=js"
export * from "./ArrivalCaptureDetail.vue?vue&type=script&lang=js"
import "./ArrivalCaptureDetail.vue?vue&type=style&index=0&id=4e9bc866&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e9bc866",
  null
  
)

export default component.exports